import React, { FC } from 'react';
import { Quote } from './CompanyFieldAndHelpers';
import { WWWCompanyDocument } from '../../../common/documents/WWWCompanyDocument';
import styled, { css } from 'styled-components';
import { useCompanyDictionary } from './CompanyDictionary';
import { mediaQuery } from '../Theme';

const LargeQuote = styled(Quote)`
  min-height: 30.7px; // This is to make the height of the quote column the same as the turnover column
  white-space: pre;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word;

  word-break: break-all;
  word-break: break-word;
`;

const References = styled.article`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    display: block;
    bottom: -2.2rem;
    left: 50%;
    width: 100%;
    height: 2px;
    background-color: #f0f0f0;
    transform: translateX(-50%);
  }

  > div:last-of-type {
    display: flex;
    flex-direction: column;
    margin-top: 4px;

    span {
      display: flex;
    }

    b {
      display: block;
      width: 100px;
      color: #222222;
    }
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 4.4rem;
  padding: 1.2rem 3.2rem 2rem 3.2rem;

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
    width: 2px;
    height: calc(100% - 2rem);
    background-color: #f0f0f0;
    transform: translateX(-50%);
  }

  > article {
    width: calc(50% - 2.2rem);
  }

  ${mediaQuery.small(css`
    padding: 1.2rem 2rem 2rem 2rem;

    &::before {
      display: none;
    }

    > article {
      width: 100%;
    }
  `)}
`;

export interface CompanyReferenceInfoProps {
  company: WWWCompanyDocument;
  editable: boolean;
  premium: boolean;
  loading: boolean;
}

export const CompanyReferenceInfo: FC<CompanyReferenceInfoProps> = ({ company }) => {
  const { references } = company;

  const dictionary = useCompanyDictionary();

  return (
    <Container>
      {references.map((item) => (
        <References>
          <LargeQuote>{item.description}</LargeQuote>
          <div>
            <span>
              <b>{dictionary.referencesValue}</b> {item.value} €
            </span>
            <span>
              <b>{dictionary.referencesDate} </b> {item.date}
            </span>
            <span>
              <b>{dictionary.referencesCustomer} </b> {item.customer}
            </span>
          </div>
        </References>
      ))}
    </Container>
  );
};
